var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card mb-3 p-3"},[_c('div',{staticClass:"d-flex"},[_c('UserPhoto',{attrs:{"user":_vm.item,"size":"48"}}),_c('div',{staticClass:"pl-2"},[_c('h4',{staticClass:"ml-1 mt-3"},[_vm._v(_vm._s(_vm.item.first_name)+" "+_vm._s(_vm.item.surname)+" ")]),_c('router-link',{staticClass:"stretched-link",attrs:{"to":{
                        name: 'users.show',
                        params: { user_id: _vm.item.id }
                    }}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }